import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { ErrorBoundary } from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// Unregister stale non-push service workers; preserve the push notification SW (/sw.js)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(r => {
      if (r.active && r.active.scriptURL && r.active.scriptURL.includes('/sw.js')) return;
      r.unregister();
      return;
    });
  });

  // Force an update check on every app load, and reload once the new worker
  // takes control. Without this, an already-installed PWA (Android home
  // screen app) can keep running an old /sw.js — and therefore an old
  // cached JS/CSS bundle — indefinitely, since Android only checks for a
  // new service worker on its own schedule, not on "clear app cache".
  navigator.serviceWorker.getRegistrations().then(registrations => {
    const reg = registrations.find(r => r.active && r.active.scriptURL && r.active.scriptURL.includes('/sw.js'));
    if (!reg) return;
    reg.update().catch(() => {});
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}

reportWebVitals();
